export default function changeDrtReducer(currentLan, action) {
    switch (action.type) {
        case "toggled": 
        return {
            lan: currentLan.lan === "ltr" ? "rtl" : "ltr",
            momentLocale: currentLan.momentLocale === "ar" ? "en" : "ar",
            language: currentLan.language === "arabic" ? "انجليزي" : "arabic",
            nexLan: currentLan.nexLan === "ar" ? "en" : "ar",
        }

        default: {
            throw Error("Unknown action" + action.type)
        }
    }
}